import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appCapsLock]',
  standalone: true,
  exportAs: 'capsLock',
})
export class CapsLockWarningDirective {
  capsOn = false;

  @HostListener('keyup', ['$event'])
  @HostListener('keydown', ['$event'])
  onKey(event: KeyboardEvent) {
    this.capsOn = event.getModifierState?.('CapsLock') ?? false;
  }

  @HostListener('blur')
  onBlur() {
    this.capsOn = false;
  }
}
